import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import ContactModule from 'modules/contact';
import PagesModule from 'modules/pages';
import pageLayout from 'HOC/pageLayout';
import PageTitle from 'components/PageTitle';
import ContactForm from './ContactForm';


const ContactUs = props => {
  const { isFetching, isFetched, interestsList, getInterests, data, getData, user, isAuth } = props;
  const [interests, setInterests] = useState([]);

  const seo = data?.seo;

  useEffect(() => {
    getInterests();
    getData('contact-us');
  }, []);

  if (interestsList && interestsList.length > 0 && interestsList.length !== interests.length) {
    const newInterests = interestsList.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
    });
    setInterests(newInterests);
  }

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords}></meta>
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        <PageTitle title="How can we help you?" />

        <div className="content-container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                {
                  isAuth
                    ? user && user.id && <ContactForm interests={interests} user={user} />
                    : <ContactForm interests={interests} user={user} />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default compose(
  pageLayout(),
  connect(
    (state) => {
      const { isFetching, isFetched, interests } = state.contact;
      const { userData } = state.profile;
      const { isAuth } = state.auth;
      const contact_us = state.pages['contact-us'];
      return { isFetching, isFetched, interestsList: interests, data: contact_us, user: userData, isAuth };
    },
    {
      getInterests: ContactModule.getInterests,
      getData: PagesModule.fetch,
    }
  ),
)(ContactUs);